import $ from 'jquery';
import '../../css/line-chat.css';
import urlParser from '../../js/urlParser';

const includeLinechat = () => {
	/**
	 * Add function to implement the app Ex: Line Chat
	 */
	function openTab(url) {
		// Create link in memory
		const a = window.document.createElement("a");
		a.target = '_blank';
		a.href = url;

		// Dispatch fake click
		const e = window.document.createEvent("MouseEvents");
		e.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		a.dispatchEvent(e);
	}

	/**
	 * Add lint chat
	 */
	$(document).ready(() => {
		const $lineWrap = $('#wrap-line');
		const $fbWrap = $('#wrap-fb');
		const $boxWrap = $('#wrap-box');
		const $closeButton = $('#closeBtn');

		$lineWrap.click(() => {
			// detect user touch what is pc or mobile and tablet, if is mobile or tablet call openTab
			if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				if (urlParser.branch === 'kaohsiung') {
					openTab('https://s.no8.io/link/channels/QIiUTtvoCN');
				}

				if (urlParser.branch === 'hualien') {
					openTab('https://s.no8.io/link/channels/l4yHUx3w54');
				}

				if (urlParser.branch === 'xinzhuang') {
					openTab('https://line.me/R/ti/p/%40swl1868d');
				}
			} else {
				$lineWrap.addClass('close');
				$lineWrap.removeClass('open');
				$boxWrap.addClass('box-show');
				$boxWrap.removeClass('box-hidden');
				$lineWrap.removeClass('animated fadeIn');
				$lineWrap.addClass('animated fadeOut');
				$boxWrap.removeClass('animated fadeOut');
				$boxWrap.addClass('animated bounceInUp');
			}
		});

		$closeButton.click(() => {
			$lineWrap.addClass('open');
			$lineWrap.removeClass('close');
			$boxWrap.addClass('box-hidden');
			$boxWrap.removeClass('box-show');

			$lineWrap.removeClass('animated fadeOut');
			$lineWrap.addClass('animated fadeIn');
			$boxWrap.removeClass('animated bounceInUp');
			$boxWrap.addClass('animated fadeOut');
		});

		$fbWrap.click(() => {
			window.open("http://m.me/chateaudechinekaohsiung");
		});
	});
};

export default includeLinechat;



// WEBPACK FOOTER //
// ./src/js/common/includeLinechat.js